import { ChainId } from '@ui/types/chain';
import { Address } from 'viem';

import { ExchangePool } from '../types';

const ADAPTER_V2_TESTNET = '0xe3F9d9f1b12c7Eca9751ac8156053eAB6101D170';
const ADAPTER_V3_TESTNET = '0x562729a9240d031a2c5ee6381a5A02aFCF834F25';

// Adapter Address
const ADAPTER_V2_MAINNET = '0x096FaC98CC942E1E3168f27Dc0630FC7f8E8fE04';
const ADAPTER_V3_MAINNET = '0xD7Ae751ec282f90Af794738F80909D0E94B4908b';

// Router & Quoter (V3)
const ROUTER_V3_TESTNET = '0x1b81D678ffb9C0263b24A97847620C99d213eB14';
const QUOTER_V3_TESTNET = '0x4c650FB471fe4e0f476fD3437C3411B1122c4e3B';

// Router (V2)
const ROUTER_V2_TESTNET = '0xB1Bc24c34e88f7D43D5923034E3a14B24DaACfF9';

// Mainnet (Assuming same for now)
const ROUTER_V3_MAINNET = '0x1b81D678ffb9C0263b24A97847620C99d213eB14';
const QUOTER_V3_MAINNET = '0x4c650FB471fe4e0f476fD3437C3411B1122c4e3B';
const ROUTER_V2_MAINNET = '0xB1Bc24c34e88f7D43D5923034E3a14B24DaACfF9';

// Fees: 0.01%, 0.05%, 0.3%, 1%
const FEES = [100, 500, 3000, 10000];

const createV3Pools = (chainId: ChainId, router: Address, quoter: Address, adapter: Address): ExchangePool[] => {
  return FEES.map((fee) => ({
    name: `Uniswap V3 ${fee / 10000}%`,
    adapter: adapter,
    router,
    quoter,
    fee,
    type: 'v3',
    icon: '/images/uniswap.svg',
  }));
};

export const UNISWAP_POOLS: Record<ChainId, ExchangePool[]> = {
  [ChainId.MONAD_MAINNET]: [
    {
      name: 'Uniswap V2',
      adapter: ADAPTER_V2_MAINNET,
      router: ROUTER_V2_MAINNET,
      type: 'v2',
      icon: '/images/uniswap.svg',
    },
    ...createV3Pools(ChainId.MONAD_MAINNET, ROUTER_V3_MAINNET, QUOTER_V3_MAINNET, ADAPTER_V3_MAINNET),
  ],
  [ChainId.MONAD_TESTNET]: [
    {
      name: 'Uniswap V2',
      adapter: ADAPTER_V2_TESTNET,
      router: ROUTER_V2_TESTNET,
      type: 'v2',
      icon: '/images/uniswap.svg',
    },
    ...createV3Pools(ChainId.MONAD_TESTNET, ROUTER_V3_TESTNET, QUOTER_V3_TESTNET, ADAPTER_V3_TESTNET),
  ],
};

